import "./ShapeOne.css";

export default function ShapeOne() {
  return (
    <div className="shape-1">
      <p>Hey! Need an inspiration for your day?</p>
    </div>
  );
}
